var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.block.buttons),function(item,index){return _c('div',{key:index},[_c('dynamic-button',{attrs:{"button":item}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }